import { getCanonicalPostUrl } from './post-utils';

export const getTagListItems = (posts, postPageSectionUrl) =>
  posts.map(post => `${getCanonicalPostUrl({ post, postPageSectionUrl })}/`);
